import {easeInOutQuad} from 'easings.js';
import scrrroll from 'scrrroll';
import em2px from '@/utils/em2px';

scrrroll.duration = 1000;
scrrroll.easing = easeInOutQuad;

export default function (dom, opts) {
	var options = {
		...opts

	};

	const links = Array.from(dom.querySelectorAll('a[href^="#"]'));
	const targets = [];

	const targetMargin = em2px(2);
	let height = dom.clientHeight;
	let currentTarget;

	links.forEach(link => {
		const target = document.querySelector(link.getAttribute('href'));

		if (target) {
			targets.push(target);
		}

		link.addEventListener('click', e => {
			e.preventDefault();

			if (target) {

				const top = target.getBoundingClientRect().top;
				const scroll = window.pageYOffset;
				const destination = Math.ceil(top + scroll) - height;

				scrrroll.to(destination);
			}
		});
	});

	window.addEventListener('scroll', e => {
		const current = [...targets].reverse().find(target => window.pageYOffset >= target.offsetTop - height - targetMargin);

		if (current && current != currentTarget) {
			const currentLink = links.find(link => {
				return link.getAttribute('href') == `#${current.id}`;
			});
			links.forEach(link => link.classList.remove('active'));
			currentLink.classList.add('active');
		}
		else if (!current) {
			links.forEach(link => link.classList.remove('active'));
		}
		currentTarget = current;
	});

	window.addEventListener('resize', e => {
		height = dom.clientHeight;
	});
}
